module.exports = __webpack_public_path__ + "static/media/Blue-background-logo-no-name.8f61de65.png";